import {isNil, isString} from 'lodash';
import rasterMapStylesFactory from 'Map/tier/styleParts/rasterMap';
import wmsMapStylesFactory from 'Map/tier/styleParts/wmsMap';
import styleResolver, {SOURCE_RASTER, SOURCE_VECTOR} from './styleParts/styleResolver';
import {vectorMapStyleResolver} from './styleParts/vectorStyleResolver';
import initializeStyleOption from 'Map/tier/styleParts/initializeStyleOption';
import {mapPolygonsUrlTransformer} from 'Map/tier/urlTransformers/urlTransformers';

export const ID = 'map';
export const SYMBOLS_ID = ID + 'Symbols';

const FALLBACK_DATA_SOURCE = SOURCE_VECTOR;

class MapTier {
    constructor(options, position, {isSymbolLayer = false} = {}) {
        this.position = position;
        const styleResolverFactory = (styleResolverOptions) => {
            const unwrapedTheme = styleResolverOptions.unwrapedTheme;
            return styleResolver(
                unwrapedTheme,
                () => rasterMapStylesFactory(
                    isSymbolLayer ? 'labels' : unwrapedTheme.layer,
                    unwrapedTheme.style,
                    isSymbolLayer ? 'labels' : ''
                ),
                () => vectorMapStyleResolver({...options, unwrapedTheme}),
                () => wmsMapStylesFactory(unwrapedTheme.format)
            );
        };

        const styleResolverOptions = {...options};
        this.style = initializeStyleOption(styleResolverOptions, styleResolverFactory);
        this.isSymbolLayer = isSymbolLayer;
        this.language = options.language;
        this.geopoliticalView = options.geopoliticalView;
        const dataSource = (options.theme && options.theme.getSource()) || FALLBACK_DATA_SOURCE;
        this.urlTransformer = mapPolygonsUrlTransformer(options.key, dataSource,
            () => this.language, () => this.geopoliticalView);
        this.options = options;
    }
    getId = () => this.isSymbolLayer ? SYMBOLS_ID : ID;
    getPosition = () => this.position;
    getStyle = () => this.style;
    setStyle = (style) => {
        const newStyle = {...style};
        newStyle.layers = [...newStyle.layers].filter(layer => !this.isSymbolLayer ?
            layer.type !== 'symbol' : layer.type === 'symbol');

        this.style = newStyle;
    };
    getOptions = () => this.options;

    _updateProperty = (propertyName, propertyValue) => {
        if (isNil(propertyValue)) {
            return false;
        }
        if (this[propertyName] === propertyValue) {
            return false;
        }
        this[propertyName] = propertyValue;
        return true;
    };

    onAdd = (map) => {
        this._map = map;
    };

    _repaintTier = () => {
        if (isString(this.getStyle()) || !this._map) {
            return;
        }

        const sourceName = Object.keys(this.getStyle().sources)[0];
        this._map.__om.style.sourceCaches[sourceName].clearTiles();
        this.getStyle().layers.forEach((layer) => this._map.setLayoutProperty(layer.id, 'visibility', 'none'));
        this.getStyle().layers.forEach((layer) => this._map.setLayoutProperty(layer.id, 'visibility', 'visible'));
    };

    setLanguage = (language) => {
        if (this._updateProperty('language', language)) {
            this._repaintTier();
            return true;
        }

        return false;
    };

    setGeopoliticalView = (geopoliticalView) => {
        if (this._updateProperty('geopoliticalView', geopoliticalView)) {
            this._repaintTier();
            return true;
        }

        return false;
    };

    getUrlTransformer = () => this.urlTransformer;

    isRaster = () => this.options && this.options.theme && this.options.theme.getSource() === SOURCE_RASTER;
}

export default (options, position, tierOptions) => {
    return new MapTier(options, position, tierOptions);
};



// WEBPACK FOOTER //
// ./map/tier/mapTier.js